import { Kit } from "./components/Kit";
import { KitImage } from "./components/KitImage";
import { useCalculatorContext } from "./context";
import { actions } from "./reducer";
import { Kit as KitType, VendorCatalog } from "./types";
import { sortVendorsByAlphabet } from "../../utils";
import { useContext, useState } from "preact/hooks";
import CalcTypeContext from "./commonContext";

interface HeaderProps {
  vendors: Array<VendorCatalog>;
  currentKitIndex: number;
  serviceKits: KitType[];
  currentVendorIndex: number;
}

// Buttons for each vendor
let buttons = {
  AJAX: (
    <svg
      width="80"
      height="16"
      viewBox="0 0 80 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M62.2417 0.703979H57.825L75.5333 15.992H79.95L62.2417 0.703979ZM67.3583 11.584L62.25 15.992H57.8333L62.9333 11.584H67.3583ZM74.85 5.11198L79.9583 0.703979H75.5417L70.4333 5.11198H74.85ZM11.0667 0.703979L9.25833 3.19198L18.4833 15.992H22.1333L11.0667 0.703979ZM6.38333 7.17598H10L3.65 15.992H0L6.38333 7.17598ZM44.3667 0.703979L42.5583 3.19198L51.7833 15.992H55.4333L44.3667 0.703979ZM39.6833 7.17598H43.3L36.95 15.992H33.3L39.6833 7.17598ZM29.3583 0.703979L29.3667 10.064C29.3583 11.584 28.6167 13.48 26.125 13.64H25.2167V15.992C25.2167 15.992 26.0083 15.992 26.525 16C27.725 16.016 29.4583 15.456 30.5333 14.352C32.0417 12.816 32.225 10.856 32.225 9.91198V0.703979H29.3583Z"
        fill="black"
      />
    </svg>
  ),
  "C.Nord": <img src="/local/templates/Leggis/assets/images/nord.png" />,
};

export function Header(props: HeaderProps) {
  const { serviceKits, vendors, currentKitIndex, currentVendorIndex } = props;
  const { state, dispatch } = useCalculatorContext();
  const sortedVendors: VendorCatalog[] = sortVendorsByAlphabet(vendors);
  const [showImage, setShowImage] = useState(true);

  function vendorChange(index: number, item: VendorCatalog) {
    dispatch(actions.setCurrentVendorIndex(index));
    // TODO: Move get vendors to vendors selector <13-06-21,14-06-21> //
    dispatch(actions.setCurrentProducts(sortedVendors[index].products));
    dispatch(
      actions.setProductsSum(sortedVendors[currentVendorIndex].base_cost)
    );
    setShowImage(false);
    dispatch(actions.setCurrentVendor(item));
    setShowImage(true);
  }

  function isCurrentImage() {
    return (
      vendors[currentVendorIndex].kit_image === state.currentVendor.kit_image
    );
  }

  let commonContext = useContext(CalcTypeContext);
  console.log(commonContext);

  let placeTypes: Array<{
    type: "flat" | "house" | "business";
    title: string;
  }> = [
    {
      type: "flat",
      title: "Квартира",
    },
    {
      type: "house",
      title: "Дом",
    },
    {
      type: "business",
      title: "Бизнес",
    },
  ];

  return (
    <>
      <div className="single-serviceConsole__kits__wrapper-block reveal">
        <div className="single-serviceConsole__kits__wrapper-block-item">
          {commonContext.isCommon && (
            <>
              <h4 className={"kits__caption"}>Тип объекта</h4>
              <div className="single-serviceConsole__kits__wrapper-block-item-buttons">
                <div className="header-buttons">
                  {placeTypes.map((place, i) => (
                    <div
                      className={`kit-price ${
                        place.type === commonContext.type ? "active" : ""
                      }`}
                      onClick={() => {
                        commonContext.setType(place.type);
                        dispatch(actions.setServiceType(place.type));
                      }}
                    >
                      <span className="kit-button-text">{place.title}</span>
                    </div>
                  ))}
                </div>
              </div>
            </>
          )}

          {serviceKits.length > 1 && (
            <>
              <h4 className={"kits__caption"}>Готовые решения</h4>
              <div className="single-serviceConsole__kits__wrapper-block-item-buttons">
                <div className="header-buttons">
                  {serviceKits.map((kit, i) => (
                    <Kit
                      item={kit}
                      sum={100000}
                      index={i}
                      currentKitIndex={currentKitIndex}
                    />
                  ))}
                </div>
              </div>
            </>
          )}
          {sortedVendors.length > 1 && (
            <>
              <h4 className={"kits__caption"}>Производитель</h4>
            </>
          )}

          <div className="single-serviceConsole__kits__wrapper-block-item-buttons">
            {sortedVendors.length > 1 && (
              <>
                <div className="header-buttons">
                  {vendors &&
                    sortedVendors.map((vendor: VendorCatalog, i: number) => (
                      <div
                        onClick={() => vendorChange(i, vendor)}
                        className={`kit-price ${
                          currentVendorIndex == i ? "active" : ""
                        }`}
                      >
                        {buttons[vendor.name]}
                      </div>
                    ))}
                </div>
              </>
            )}
            <div className="kit-things-description">
              <h4 className={"kits__caption"}>Состав и цена комплекта</h4>
              <p className={"kits__description"}>
                {sortedVendors[currentVendorIndex].base_text} —{" "}
                <span className={"price"}>
                  {sortedVendors[currentVendorIndex].base_cost} руб.
                </span>
              </p>
            </div>
          </div>
          <div className="base-price-block">
            <h4 className="diclaimer">
              {sortedVendors[currentVendorIndex].name} официальный партнер ГК
              "ЛЕГИС".
            </h4>
          </div>
        </div>
      </div>
      <div className="single-serviceConsole__kits__wrapper-block kit-images">
        <KitImage
          isCurrentImage={isCurrentImage}
          image={state.currentVendor.kit_image}
          width={state.currentVendor.image_width}
          height={state.currentVendor.image_height}
        />
      </div>
    </>
  );
}
